import NewProjectButton from './NewProjectButton';
import ProjectsSidebar from './ProjectsSidebar';
import React from 'react';
import monitors from '../assets/images/monitors.jpg';
import {Box, Flex, Heading, Spinner, Text} from '@chakra-ui/react';
import {LIST_PROJECTS} from '../utils/queries';
import {ProjectsContext} from '../utils';
import {useQuery} from '@apollo/client';

export default function ListProjects() {
  const {data, loading, error} = useQuery(LIST_PROJECTS);

  if (loading) {
    return (
      <Box m="auto">
        <Spinner display="block" size="lg" />
      </Box>
    );
  }

  if (error) {
    return <Text color="red.500">{error.message}</Text>;
  }

  return (
    <ProjectsContext.Provider value={data.projects}>
      <ProjectsSidebar />
      <Flex
        display={{base: 'none', md: 'flex'}}
        grow="1"
        p="10"
        bgImage={`url(${monitors})`}
        bgSize="cover"
        bgPos="center"
      >
        <Box
          my="auto"
          w={{
            base: 'full',
            lg: '50%'
          }}
        >
          <Heading mb="4" fontWeight="semibold">
            Let&apos;s get organized
          </Heading>
          <Text mb="6" fontSize="lg">
            Divide your music into individually playable blocks. Open a project
            or create a new one to get started.
          </Text>
          <NewProjectButton variant="outline" />
        </Box>
      </Flex>
    </ProjectsContext.Provider>
  );
}
